import * as Y from 'yjs'
import { create } from 'zustand'
import * as yProtocolAwareness from 'y-protocols/awareness'

export const useYjsStore = create<{
  docs: Map<
    string,
    {
      doc: Y.Doc
      undoManager: Y.UndoManager
      lastAppliedValueRef: { current: string }
      awareness: yProtocolAwareness.Awareness
    }
  >
}>(() => ({ docs: new Map() }))
